import { useEffect } from "react";
// Não precisamos mais de PubSub ou TPost aqui se a lógica de scroll for removida
// import PubSub from "pubsub-js";
// import { TPost } from "../../../models/posts.model";

// Removida importação não utilizada:
// import { TimelineD3ChartsZoom } from "../TimelineD3Charts";

export function useTimelineChartZoom({
  svgRef,
}: // Props podem ser removidas se o hook não fizer mais nada com elas
// width,
// height,
// dateMax,
// dateMin,
// days,
// focusedPost,
{
  width: number;
  height: number;
  svgRef: React.RefObject<SVGSVGElement | null>;
  dateMin: Date;
  dateMax: Date;
  days: number;
  focusedPost?: any; // Ou TPost se importado e necessário para outra lógica
}) {
  // A lógica original de zoom por scroll (Ctrl+Wheel) foi removida
  // para implementar o controle de zoom por botões e níveis fixos
  // centralizados na data atual ou selecionada, conforme implementado
  // no componente TimelineD3Charts.

  /*
  // Código original comentado:
  const nextZoom = [...TimelineD3ChartsZoom].reverse().find((z) => z > days);
  const previousZoom = [...TimelineD3ChartsZoom].find((z) => z < days);

  useEffect(() => {
    function onScroll(event: any) {
      if (!event.ctrlKey) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (event.deltaY > 0) { // Zoom out attempt
        if (nextZoom) {
          // ... lógica antiga de zoom out baseada em nextZoom e focusedPost ...
          // PubSub.publish("timeline:zoom", { ... });
        }
      } else if (event.deltaY < 0) { // Zoom in attempt
        if (previousZoom) {
          // ... lógica antiga de zoom in baseada em previousZoom e focusedPost ...
           // PubSub.publish("timeline:zoom", { ... });
        }
      }
    }

    const currentSvgRef = svgRef?.current;
    if (currentSvgRef) {
      currentSvgRef.addEventListener("wheel", onScroll, { passive: false }); // passive: false if preventDefault is used
    }

    return () => {
      currentSvgRef?.removeEventListener("wheel", onScroll);
    };
  }, [
    svgRef, // Acesso a .current dentro do effect
    focusedPost?.id, // Usar focusedPost?.id ou o objeto todo
    dateMin,
    dateMax,
    nextZoom,
    previousZoom,
    width,
    height,
    days // Adicionado days se usado no cálculo
    // Remover dependências não utilizadas se a lógica for removida
  ]);
  */

  // O hook agora não executa a lógica de zoom por scroll.
  // Pode ser usado no futuro para outras funcionalidades de zoom/pan.
  return null;
}
